import {ProductGalleryBaseImageContainer as SourceProductGalleryBaseImageContainer} from 'SourceComponent/ProductGalleryBaseImage/ProductGalleryBaseImage.container';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { withRouter } from 'react-router';
export class ProductGalleryBaseImageContainer extends SourceProductGalleryBaseImageContainer {


    containerProps = () => ({
        alt: this._getAlt(),
        src: this._getSrc(),
        productName: this._getProductName()
    });

    _getProductName() {
        const { productName } = this.props;
        return productName || '';
    }
}

export default withRouter(ProductGalleryBaseImageContainer);
